import { render } from "./StreamCard.vue?vue&type=template&id=af84b15a&scoped=true"
import script from "./StreamCard.vue?vue&type=script&lang=js"
export * from "./StreamCard.vue?vue&type=script&lang=js"

import "./StreamCard.vue?vue&type=style&index=0&id=af84b15a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af84b15a"]])

export default __exports__